/* Publish by EComposer at 2026-10-14 17:09:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rcwmhln460c"]=  window.__ectimmers["ecom-rcwmhln460c"] || {};
if(!this.settings||!this.$el||this.isLive)return;const t=this.$el;let e=t.querySelectorAll('script:not([type="application/json"])');e.length>0&&e.forEach(function(i){let s=document.createElement("script");s.type="text/javascript",s.innerText=i.innerText,i.src&&(s.src=i.src),t.appendChild(s),i.remove()})

                    });
                    
                        document.querySelectorAll('.ecom-rcwmhln460c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rcwmhln460c', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p7a1a4etfl"]=  window.__ectimmers["ecom-p7a1a4etfl"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-p7a1a4etfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p7a1a4etfl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bot4spx6pzj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bot4spx6pzj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q7jnabb2ca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q7jnabb2ca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-phwwkowdjqm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-phwwkowdjqm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ii8l00p9okg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ii8l00p9okg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5y5vscuhnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5y5vscuhnm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-do3wx6wvq7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-do3wx6wvq7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8qizivdzool').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qizivdzool', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dp0z0azdqfp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dp0z0azdqfp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7xpez49y60s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7xpez49y60s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qrouf62344').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qrouf62344', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xr5uimxz4g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xr5uimxz4g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ez4ywmj4i3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ez4ywmj4i3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifdrsf6lr2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifdrsf6lr2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vaehgft8te7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vaehgft8te7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-paims5bntll').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-paims5bntll', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0jyvmwfm2dc6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jyvmwfm2dc6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7t34oro7pae').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7t34oro7pae', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8buyu7e5o3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8buyu7e5o3q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t81hh22ths8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t81hh22ths8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5dvjlz5fhz9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5dvjlz5fhz9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vijozlp506l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vijozlp506l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-374p93zhhl1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-374p93zhhl1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5kw1nomjmjw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5kw1nomjmjw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6kegn5gu2cl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6kegn5gu2cl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmc2ak2hmre').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmc2ak2hmre', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a2h43dfzwvu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a2h43dfzwvu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p26g6pgo5la').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p26g6pgo5la', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q745yd1adw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q745yd1adw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i8jqur35sas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i8jqur35sas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2f25snj5co5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2f25snj5co5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iv9a97vqwu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iv9a97vqwu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2i59m1okvb4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2i59m1okvb4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ouljwum4ecn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ouljwum4ecn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u2xpzirjfqp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u2xpzirjfqp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifwvptjbh57').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifwvptjbh57', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8nb5hsbhmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8nb5hsbhmp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6xesqdvkq9s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6xesqdvkq9s', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0uwz6mantfhn"]=  window.__ectimmers["ecom-0uwz6mantfhn"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-0uwz6mantfhn"]["bd9axafih"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-0uwz6mantfhn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0uwz6mantfhn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-58xrzh4z0ic"]=  window.__ectimmers["ecom-58xrzh4z0ic"] || {};
var e=this.$el;if(e&&this.isLive){var t=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");t.length&&t.forEach(function(i){var a=i.getAttribute("href")||"#",r=a.replace("{current-link}",location.href);i.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-58xrzh4z0ic').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-58xrzh4z0ic', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}